/*
 * @Description:
 * @Date: 2020-11-06 16:31:41
 */
import { moneyFixed } from '@/tools/money';

import { payStatusRender } from '@/page/settlementCenter/utils';

// 结算总价列表 带入了相关接口与参数： 部分/已支付/失效
export { projectPriceHanderl } from '@/page/settlementCenter/common/tableConfig/fields';

import dateFormat from '@/tools/dateFormat';

export default {
  index: {
    width: '60px',
    label: '序号',
    type: 'index'
  },
  orderNo: {
    label: '订单编号',
    prop: 'orderNo'
  },
  fullName: {
    label: '项目参与人',
    prop: 'fullName'
  },
  userPhone: {
    label: '手机号',
    prop: 'userPhone'
  },
  bankNo: {
    label: '收款账号',
    prop: 'bankNo'
  },
  collectMoneyprop: {
    label: '收款方式',
    prop: 'collectMoneyType'
  },
  projectName: {
    label: '项目名称',
    prop: 'projectName'
  },
  taskDt: {
    label: '任务月度',
    prop: 'taskDt'
  },
  createDate: {
    label: '提交日期',
    prop: 'createDt',
    formatter(r, c, v) {
      return dateFormat(v) || '-';
    }
  },
  supplierName: {
    label: '供应商',
    prop: 'supplierName'
  },
  payee: {
    label: '收款方',
    prop: 'fullName'
  },
  finishSum: {
    label: '实际完成任务量',
    prop: 'finishSum'
  },
  taskPrice: {
    label: '终端结算单价',
    prop: 'taskPrice',
    render: function(h, ctx, r, c) {
      const val = moneyFixed([r[c.property]]);
      const { type } = ctx.parent.$parent;
      if ([2, 3, 4].includes(type) && r.supplierId) {
        return h('span', '-');
      }
      return h('span', val);
    }
  },
  finishSumTaskPrice: {
    label: '终端结算金额',
    prop: 'finishSumTaskPrice',
    render: function(h, ctx, r, c) {
      const val = moneyFixed([r[c.property]]);
      const { type } = ctx.parent.$parent;
      if ([2, 3, 4].includes(type) && r.supplierId) {
        return h('span', '-');
      }
      return h('span', val);
    }
  },
  commission: {
    label: '服务费率',
    prop: 'commission',
    formatter(r, c, v) {
      if (!r.supplierName) {
        return '-';
      }
      return (v / 100).toFixed(2) + '%';
    }
  },
  totalPrice: {
    label: '结算总价',
    prop: 'totalPrice',
    formatter(r, c, v) {
      return moneyFixed(v);
    }
  },
  payStatus: {
    label: '支付状态',
    prop: 'payStatus',
    width: '140px',
    render: (h, ctx, r) => {
      return (
        <div>
          <span>{payStatusRender(r, null)}</span>
        </div>
      );
    }
  },
  payStatus03: {
    label: '支付状态',
    prop: 'payStatus',
    width: '120px',
    render: (h, ctx, r) => {
      return (
        <div>
          <span>{payStatusRender(r, 3)}</span>
        </div>
      );
    }
  },
  finishPayDt: {
    label: '到账时间',
    prop: 'finishPayDt'
  },
  // 支付类型 只会有 供应商和自然人
  payProjectStructureType: {
    label: '支付类别',
    formatter(row) {
      // 目前理论上不会有个体
      return row.supplierId
        ? '供应商'
        : ['自然人', '个体', '自然人'][row.projectStructureType - 1];
    }
  },
  // 结算总价
  projectPrice: {
    label: '结算总价',
    prop: 'projectPrice',
    formatter(r, c, v) {
      return moneyFixed(v);
    }
  },
  endPointFinishPayDt: {
    label: '终端到账时间',
    prop: 'endPointFinishPayDt'
  },
  download: {
    label: '操作',
    prop: 'download',
    width: '80px',
    render(h, ctx, row) {
      const vm = ctx.parent;
      const handler = () => {
        vm.$download(row.bankPayVoucherUrl);
      };
      return (
        <div>
          <el-button
            type="text"
            disabled={!row.bankPayVoucherUrl || row.bankPayVoucherUrl === '-'}
            onClick={handler}
          >
            下载回单
          </el-button>
        </div>
      );
    }
  }
};
